import React from "react";

const MembershipHeaderActions = (props) => {
    const {isMember, memberInfo, activeScreen, setActiveScreen, setIsMember, setRefetchingMemberData} = props;

    if (activeScreen == 'login') {
        return (
            <div className="membership__header-actions">
                <button
                    className="membership__go-back link"
                    onClick={() => {
                        setActiveScreen('levels');
                    }}
                >
                    Back to Levels
                </button>
            </div>
        )
    } else if (isMember) {
        return (
            <div className="membership__header-actions">
                {activeScreen != 'dashboard' && activeScreen != 'confirmation' &&
                    <button
                        className="membership__go-back link"
                        onClick={() => {
                            setActiveScreen('dashboard');
                        }}
                    >
                        Back to Dashboard
                    </button>
                }
                {activeScreen == 'confirmation' &&
                    <button
                        className="membership__go-back link"
                        onClick={() => {
                            setRefetchingMemberData(true);
                        }}
                    >
                        Back to Dashboard
                    </button>
                }
                <button
                    className="membership__sign-out link"
                    onClick={() => {
                        setActiveScreen('levels');
                        setIsMember(false);
                    }}
                >
                    Sign out
                </button>
            </div>
        );
    } else {
        return (
            <div className="membership__header-actions">
                {activeScreen != 'levels' &&
                    <button
                        className="membership__go-back link"
                        onClick={() => {
                            setActiveScreen('levels');
                        }}
                    >
                        Back to Levels
                    </button>
                }
                <span className="membership__header-actions-query">Already a member?</span>
                <button
                    className="button button--small membership__become-a-member"
                    onClick={() => {
                        setActiveScreen('login');
                    }}
                >
                    Sign in
                </button>
            </div>
        );
    }
}

export default MembershipHeaderActions;